import React from "react";
import useUploadFiles from "../../../services/hooks/useUploadFiles";
import dayjs from "dayjs";

// components

import Upload from "../../../component/modals/upload";
import TextInput from "../../../component/element/forms/TextInput";
import SelectDate from "../../../component/element/forms/SelectDate";
import Modal from "../../../component/ui/modal";
// import DateInput from "../../../component/element/forms/DateInput";

// state
import { useAppDispatch, useAppSelector } from "../../../store";
import {
  ICompanyDocument,
  ICompanyDocumentError,
  IDocument,
} from "../../../store/types/company";
import { edit_company_docs } from "../../../services/apis/company";
import { useParams } from "react-router-dom";

type IUploadDocument = {
  visible: boolean;
  onHandler: () => void;
  document?: IDocument | null;
};

const EditUploadDocument: React.FC<IUploadDocument> = ({
  visible,
  onHandler,
  document,
}) => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.company.loading);
  const { loader, uploadFile, deleteFiles } = useUploadFiles();
  const [documentId, setDocumentId] = React.useState<string>("");
  const [data, dataSet] = React.useState<ICompanyDocument>({
    name: "",
    company_id: "",
    issuing_body: "",
    expiring_date: "",
    issuing_date: "",
    path: "",
  });
  const [error, errorSet] = React.useState<ICompanyDocumentError>({
    company_id: "",
    expiring_date: "",
    issuing_body: "",
    issuing_date: "",
    name: "",
    path: "",
  });

  const handleOk = () => {
    let err;
    if (!data.company_id) {
      err = true;
      errorSet((prev) => ({ ...prev, company_id: "" }));
    }
    if (!data.name) {
      err = true;
      errorSet((prev) => ({ ...prev, name: "" }));
    }
    if (!data.expiring_date) {
      err = true;
      errorSet((prev) => ({ ...prev, expiring_date: "" }));
    }
    if (!data.issuing_body) {
      err = true;
      errorSet((prev) => ({ ...prev, issuing_body: "" }));
    }
    if (!data.issuing_date) {
      err = true;
      errorSet((prev) => ({ ...prev, issuing_date: "" }));
    }
    if (!data.path) {
      err = true;
      errorSet((prev) => ({ ...prev, path: "" }));
    }
    console.log(error);
    if (err) return;
    // Include document ID in the request if editing
    const requestData = documentId ? { ...data, id: documentId } : data;
    edit_company_docs(requestData as any, dispatch);
    onHandler?.();
  };

  const onChangeText = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target;
    dataSet((prev) => ({ ...prev, [name]: value }));
    errorSet((prev) => ({ ...prev, [name]: "" }));
  };

  const onLoad = React.useCallback(() => {
    if (id) dataSet((prev) => ({ ...prev, company_id: id }));
  }, [id]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  // Pre-fill form when document is provided
  React.useEffect(() => {
    if (document && visible) {
      setDocumentId(document.id);
      dataSet({
        name: document.name || "",
        company_id: id || "",
        issuing_body: document.issuing_body || "",
        expiring_date: document.expiring_date
          ? dayjs(document.expiring_date).format("YYYY-MM-DD hh:mm:ss")
          : "",
        issuing_date: document.issuing_date
          ? dayjs(document.issuing_date).format("YYYY-MM-DD hh:mm:ss")
          : "",
        path: document.path || "",
      });
    } else if (!document && visible) {
      // Reset form when opening without a document
      setDocumentId("");
      dataSet({
        name: "",
        company_id: id || "",
        issuing_body: "",
        expiring_date: "",
        issuing_date: "",
        path: "",
      });
    }
  }, [document, visible, id]);

  return (
    <Modal
      title="Edit Document"
      open={visible}
      onClose={onHandler}
      onOkClick={handleOk}
      variant="medium"
      isLoading={loading}
    >
      <div className="w-full ">
        <div className="">
          <Upload
            label="PDF"
            title="Upload opportunity File"
            name="opportunity_file"
            loading={loader}
            status={error.path}
            completed={data.path ? true : false}
            onChange={async (fileOrFiles) => {
              const paths = await uploadFile(fileOrFiles as File, "documents");
              if (paths.length > 0) {
                const file_path = paths[0]?.base_url + "/" + paths[0]?.path;
                dataSet((prev) => ({ ...prev, path: file_path }));
                errorSet((prev) => ({ ...prev, path: "" }));
              }
            }}
            onDelete={async () => {
              if (data.path) {
                const res = await deleteFiles(data.path);
                if (res) {
                  dataSet((prev) => ({ ...prev, path: "" }));
                  errorSet((prev) => ({ ...prev, path: "" }));
                }
              }
            }}
          />
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-3">
        <TextInput
          label="Document Name"
          name="name"
          onChange={onChangeText}
          placeholder="Document Name"
          type="text"
          value={data.name}
          status={error.name}
        />

        <TextInput
          label="Issuing Body"
          name="issuing_body"
          onChange={onChangeText}
          placeholder="Issuing Body"
          type="text"
          value={data.issuing_body}
          status={error.issuing_body}
        />

        <SelectDate
          label="Issuing Date"
          onChange={(res) =>
            dataSet((prev) => ({ ...prev, issuing_date: res }))
          }
          placeholder="Issuing Date"
          value={
            data.issuing_date
              ? dayjs(data.issuing_date, "YYYY-MM-DD hh:mm:ss")
              : undefined
          }
        />

        <SelectDate
          label="Expiring Date"
          onChange={(res) =>
            dataSet((prev) => ({ ...prev, expiring_date: res }))
          }
          placeholder="Expriring Date"
          value={
            data.expiring_date
              ? dayjs(data.expiring_date, "YYYY-MM-DD hh:mm:ss")
              : undefined
          }
        />
      </div>
    </Modal>
  );
};

export default EditUploadDocument;
